import { gsap } from 'gsap'
import MotionPathPlugin from 'gsap/MotionPathPlugin'
import { Spine } from 'pixi-spine'
import { assets } from 'utils/AssetParser'
import { SpineUtils } from 'utils/Spine-Utils'
import { utils } from 'utils/Utils'
export default  class LotteryView extends PIXI.Container {
  constructor() {
    super()
    gsap.registerPlugin(MotionPathPlugin)
    const coordinate =    [{ x: -200, y: 0 }, { x: -200, y: 0 },  { x: 0, y: 0 }]
    const path =  coordinate
    const scalePath = [{ x: 0.2, y: 0.2 },  { x: 0.5, y: 0.5 }]
    this.settings = {
      lottery: {
        bgStretch: {
          color: 0x0f0f0f,
          alpha: 0,
          x: -500,
          y: -500,
          width: 1000,
          height: 1000,
        },
        assets: {
          deckSpineName: 'shaffle',
          ticketSpineName: 'card',
        },
        deck: { scale: 0.4 },
        tweens: {
          tweenCenter: { angle: 0,  motionPath: { path: path }, ease: 'Circle.In', duration: 1.1, delay: 0.1 },
          tweenScaleCenter: { motionPath: { path: scalePath }, duration: 0.3, delay: 0.8 },
          tweenBgIn: { alpha: 0.5, ease: 'linear', duration: 0.3, delay: 0 },
          tweenBgOut: { alpha: 0, ease: 'linear', duration: 0.3, delay: 0 },
          tweenDeck: { ease: 'Bounce.Out', duration: 0.6, delay: 0.1 },
          tweenScaleBack: { ease: 'Back.Out', duration: 0.5, delay: 0.1 },
        },
        text: {
          angle: 90,
          anchor: 0.5,
          shiftPos: { x: 0, y: 0 },
          slotText: 'text_win',
          winText: 'YOU WIN',
          loseText: 'YOU LOSE',
          winStyle: {
            fontFamily: 'Druk Text Cy',
            dropShadow: true,
            dropShadowAlpha: 0.7,
            dropShadowBlur: 4,
            dropShadowDistance: 2,
            fill: [
              '#ffd500',
              '#ffc800',
              '#ffa200',
            ],
            fontSize: 80,
            strokeThickness: 2,
          },
          loseStyle: {
            dropShadow: true,
            dropShadowAlpha: 0.7,
            dropShadowBlur: 4,
            dropShadowDistance: 2,
            fill: [
              '#b60202',
              '#f00000',
              '#990000',
            ],
            fontSize: 80,
            strokeThickness: 2,
          },
        },

        ticketsSlot: ['back1', 'back2', 'back3', 'back4', 'back5', 'back6', 'back7', 'back8', 'back9', 'back10'],
        animation: {
          deck: {},
          ticket: {
            win: {
              in: 'win_in',
              loop: 'win_loop',
              out: 'win_out',
            },
            lose: {
              in: 'lose_in',
              loop: 'lose_loop',
              out: 'lose_out',
            },
            glow: 'glow',
            idle: '0',
            scratch: 'scratch',

          },
        },

      },
    }
    this._bg = null
    this._tickets = []
    this._spineDeck = null
    this._win = null

    this.createMainSpine()
    this.createStretchBg()

  }

  createStretchBg(){
    const settings = this.settings.lottery.bgStretch
    const graphics = this._bg = new PIXI.Graphics()
    graphics.beginFill(settings.color)
    graphics.drawRect(settings.x, settings.y, settings.width, settings.height)
    graphics.endFill()
    graphics.alpha = settings.alpha
    this.addChild(graphics)
  }

  enableBg(enabled) {
    const settings = this.settings.lottery.tweens
    const tween = enabled ? settings.tweenBgIn : settings.tweenBgOut
    this._bg.interactive = enabled
    this.customTween(this._bg, tween)
  }

  enableMouseOver(obj, enabled) {
    const aSettings = this.settings.lottery.animation.ticket
    obj.forEach((o) => {
      if (enabled) {
        o.interactive = true
        o.buttonMode = true
        o.on('mouseover', () => {
          o.state.setAnimation(0, aSettings.glow, true)
        })
        o.on('mouseout', () => {
          o.state.setAnimation(0, aSettings.idle, false)
        })
      }
      else {
        o.interactive = false
        o.buttonMode = false
        o.off('mouseover')
        o.off('mouseout')
        o.state.setAnimation(0, aSettings.idle, false)
      }
    })
  }

  customTween(obj, settings, stop, start) {
    const onComplete = () => {
      stop?.()
    }
    const onStart = () => {
      start?.()
    }

    const tween = gsap.to(obj, { ...settings, onComplete, onStart })

    return tween
  }

  createMainSpine() {
    const settings = this.settings.lottery

    const spine = this._spineDeck = new Spine(assets.spine[settings.assets.deckSpineName].spineData)

    spine.scale.set(settings.deck.scale)
    setTimeout(() => {
      spine.state.setAnimation(0, 'shuffl_1', false)
    }, 7000)

    this.addChild(spine)

    this.addTicketToDeck(spine, settings)

    spine.skeleton.setToSetupPose()

    this.enableMouseOver(this._tickets, true)
  }

  addTicketToDeck(spine, settings) {
    settings.ticketsSlot.forEach((slot, index) => {
      const slotSpine = this.createTicked()
      const childSpine = SpineUtils.addSpine(spine, slot, slotSpine)
      childSpine.texture = PIXI.Texture.EMPTY
      slotSpine.deckParent = childSpine
      slotSpine.id = index
      this._tickets.push(slotSpine)
    })
  }

  createTicked() {
    const settings = this.settings.lottery
    const spine = new Spine(assets.spine[settings.assets.ticketSpineName].spineData)
    spine.state.setAnimation(0, settings.animation.ticket.idle, false)
    spine.text = this.addTextTicket()
    SpineUtils.addText(spine, settings.text.slotText, spine.text, settings.text.shiftPos )
    this.enableTap(spine, this.tapOnTicket.bind(this))
    return spine
  }

  addTextTicket(){
    const settings = this.settings.lottery
    const text = new PIXI.Text(settings.text.winText, settings.text.winStyle )
    text.angle = settings.text.angle ? settings.text.angle : 0
    text.anchor.set(settings.text.anchor ? settings.text.anchor : 0.5)
    return text
  }

  enableTap(object, handler) {
    object.interactive = true
    object.buttonMode = true
    object.on('pointertap', () => {
      handler(object)
    })
  }

  checkWin() {
    const win = Math.random() < 0.5
    this._win = win ? 500 : 0
    return win
  }

  tapOnTicket(ticket) {
    const tSettings = this.settings.lottery.tweens
    const aSettings = this.settings.lottery.animation.ticket

    utils.changeParent(ticket, this)
    const tDeck = {
      x: ticket.x,
      y: ticket.y,
      angle: ticket.angle,
      ...tSettings.tweenDeck,
    }
    const tScaleBack = {
      x: ticket.scale.x,
      y: ticket.scale.y,
      ...tSettings.tweenDeck,
    }

    const tStart = () => ticket.state.setAnimation(0, aSettings.glow, false)

    this.enableMouseOver(this._tickets, false)

    this.customTween(
      ticket.scale,
      tSettings.tweenScaleCenter,
      () => {
      },
      tStart,
    )

    this.enableBg(true)

    this.customTween(ticket, tSettings.tweenCenter, () => {

      ticket.state.setAnimation(0, aSettings.idle, false)
      const anim = this.checkWin() ? aSettings.win : aSettings.lose
      this.updateTicketText(ticket)
      SpineUtils.playCallBack(ticket, aSettings.scratch, false, () => {
        this.playTicketAnimations(ticket, aSettings, tScaleBack, tDeck, anim)
      })
    })
  }

  updateTicketText(ticket){
    const textSettings = this.settings.lottery.text
    const winText = this._win > 0 ? `${textSettings.winText} \n     ${this._win}` : `${textSettings.loseText}`
    const style = this._win > 0 ? textSettings.winStyle : textSettings.loseStyle
    ticket.text.text = winText
    ticket.text.style = style
  }

  playTicketAnimations(ticket, aSettings, tScaleBack, tDeck, anim) {

    SpineUtils.playCallBack(ticket, anim.in, false, () => {
      SpineUtils.playCallBack(ticket, anim.loop, false, () => {
        SpineUtils.playCallBack(ticket, anim.out, false, () => {
          SpineUtils.playCallBack(ticket, aSettings.idle, false, () => {
            this.customTween(ticket.scale, tScaleBack)
            this.customTween(ticket, tDeck, () => {
              utils.changeParent(ticket, ticket.deckParent)
              this.enableMouseOver(this._tickets, true)
              this.enableBg(false)
            })
          })
        })
      })
    })
  }
}
